import { useCallback } from "react";
import { ReportsApi, useAPIAction } from "melco-shared-logic";
import dayjs from "dayjs";
import { StatisticsConfig } from "./useStatistics";

export const useReportsUpdateFilters = () => {
  const [reportsUpdateFilters] = useAPIAction(
    ReportsApi,
    async (api, filters: StatisticsConfig, screenName: string) => {
      await api.reportsUpdateFilters({
        reportingMelcoMachineStatisticsModelsUpdateFilter: {
          screenName: screenName,
          filtersData: {
            startDate: dayjs(filters?.startTimestamp).toDate() ?? undefined,
            endDate: dayjs(filters?.endTimestamp).toDate() ?? undefined,
            designList:
              filters?.designsFilter?.map((df: any) => df?.value).join(",") ??
              undefined,
            groupList:
              filters?.machineGroupsFilter
                ?.map((mgf: any) => mgf?.value)
                .join(",") ?? undefined,
            isGrouped: filters?.grouped,
          },
        },
      });

      return {
        successMessages: [],
      };
    },
    {
      translationPrefix: "",
    }
  );

  return useCallback(
    async (filters: any, screenName: string) => {
      try {
        await reportsUpdateFilters(filters, screenName);
      } catch (e) {
        // error handling is already done in useAPIAction
      }
    },
    [reportsUpdateFilters]
  );
};
